<template>
  <div>
    <header-applis titre="Engager le financement" sous-titre="Vous êtes une personne en recherche d’emploi" index-progression-courante="4"/>
    <div class="wrapper__content">
      <ul>
        <li>
          <p>Si vous ne l’avez pas encore fait :</p>
          <ul>
            <li>activez votre compte personnel de formation et consultez de combien il est crédité : <a href="//www.moncompteformation.gouv.fr/espace-prive/" target="_blank">www.moncompteformation.gouv.fr/espace-prive/</a>
            </li>
            <li>cependant, si vous envisagez un contrat en alternance (apprentissage, professionnalisation) et que le diplôme permet cette possibilité, vous pourrez joindre directement le service de formation indiqué</li>
          </ul>
        </li>
        <li>
          <p>Si vous êtes inscrit comme demandeur d’emploi, Pôle emploi peut étudier et financer tout ou partie de votre projet. Prenez contact avec votre conseiller Pôle Emploi :
            <a href="https://www.pole-emploi.fr/candidat/vos-demarches-aupres-de-pole-emploi-@/index.jspz?id=485694"
               target="_blank">https://www.pole-emploi.fr/candidat/vos-demarches-aupres-de-pole-emploi-@/index.jspz?id=485694</a>
          </p>
        </li>
        <li>
          <p>Si vous n’êtes pas inscrit à Pôle Emploi, identifiez et contactez votre Conseiller en Évolution Professionnelle (CEP) : <a href="https://www.mon-cep.org/" target="_blank">www.mon-cep.org</a>
          </p>
        </li>
      </ul>
    </div>
    <footer-applis ecran-precedent="choixstatutfinancement" ecran-suivant="fin" label-suivant="Terminer"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'rechercheemploifinancement',
  components: {
    FooterApplis,
    HeaderApplis
  }
}
</script>
